// extracted by mini-css-extract-plugin
export default {"scriptBox":"ScriptBox_scriptBox__loaOp","msg":"ScriptBox_msg__YLxQO","h3":"ScriptBox_h3__bvsRr","chatIcon":"ScriptBox_chatIcon__FRTsy"};